/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_SellerInputs */

const en_label_seller = /** @type {(inputs: Label_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const es_label_seller = /** @type {(inputs: Label_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const fr_label_seller = /** @type {(inputs: Label_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur`)
};

const de_label_seller = /** @type {(inputs: Label_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

const id_label_seller = /** @type {(inputs: Label_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const ja_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const zh_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const ar_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const it_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const ru_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const pt_label_seller = en_label_seller;

/** @type {(inputs: Label_SellerInputs) => LocalizedString} */
const ko_label_seller = en_label_seller;

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {Label_SellerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_seller = /** @type {((inputs?: Label_SellerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_SellerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_seller(inputs)
	if (locale === "es") return es_label_seller(inputs)
	if (locale === "fr") return fr_label_seller(inputs)
	if (locale === "de") return de_label_seller(inputs)
	if (locale === "ja") return ja_label_seller(inputs)
	if (locale === "zh") return zh_label_seller(inputs)
	if (locale === "ar") return ar_label_seller(inputs)
	if (locale === "id") return id_label_seller(inputs)
	if (locale === "it") return it_label_seller(inputs)
	if (locale === "ru") return ru_label_seller(inputs)
	if (locale === "pt") return pt_label_seller(inputs)
	return ko_label_seller(inputs)
});